<template>
  <v-row>
    <v-col cols="6" class="no-padding-y">
      <naj-input
        :type-id="formFieldType.selectbox"
        :label="typeLabel || local.personInformation.socialType"
        :value.sync="socialTypeId"
        :items="socialTypes"
        item-text="name"
        item-value="id"
        :disabled="typeDisabled"
        :validates="typeValidates"
        @change="typeChanged"
      ></naj-input>
    </v-col>
    <v-col cols="6" class="no-padding-y" v-if="socialIdVisible">
      <naj-input
        :type-id="formFieldType.text"
        :label="socialIdLabel || local.personInformation.social"
        :value.sync="socialId"
        :disabled="socialIdDisabled || !socialTypeId"
        :validates="`${socialTypeId ? 'required|' : ''}${socialIdValidates}`"
        v-mask="mask"
        @change="socialIdChanged"
        @input="socialIdInput"
      ></naj-input>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: 'naj-social-identity-input',
  inject: ['$validator'],
  props: {
    socialTypes: {
      type: Array,
      required: true,
    },
    typeValidates: {
      type: String,
    },
    typeDisabled: {
      type: Boolean,
    },
    typeLabel: {
      type: String,
    },
    socialIdValidates: {
      type: String,
    },
    socialIdDisabled: {
      type: Boolean,
    },
    socialIdLabel: {
      type: String,
    },
    socialIdMask: {
      type: String,
    },
    typeIdValue: {
      required: true,
    },
    socialIdValue: {
      required: true,
    },
    socialIdVisible: {
      type: Boolean,
      default: true,
    },
  },
  data () {
    return {
      socialTypeId: null,
      socialId: null,
    };
  },
  computed: {
    mask () {
      return this.socialIdMask || (this.socialTypeId ? `${this.socialTypeId}#########` : '');
    },
  },
  methods: {
    typeChanged (value) {
      this.$emit('typeChanged', value);
      this.$emit('update:typeIdValue', value);
    },
    socialIdChanged (value) {
      this.$emit('socialIdChanged', value);
      this.$emit('update:socialIdValue', value);
    },
    socialIdInput (value) {
      this.$emit('socialIdInput', value);
      this.$emit('update:socialIdValue', value);
    },
  },
};
</script>

<style lang="scss" scoped>
.no-padding-y {
  padding-top: 0;
  padding-bottom: 0;
}
</style>
